import axios from "./request"

export default {
  async create(data) {
    return (await axios.post('/customers', data)).data
  }
}
